import type { EstadoComunicacionUI } from '@/types/afip'

/**
 * Si una comunicación del Domicilio Fiscal Electrónico se puede mostrar sin volver a pedir la
 * confirmación legal.
 *
 * Solo la que ARCA reporta como leída: abrirla ya perfeccionó la notificación, y mostrarla de
 * nuevo no cambia nada. Cualquier otro estado pasa por la confirmación, incluido el que ARCA no
 * dejó clasificar. Abrir una comunicación la da por notificada y no se puede deshacer.
 */
export const seAbreSinConfirmar = (estado: EstadoComunicacionUI): boolean => estado === 'LEIDA'
